import { useContext, useEffect } from "react";
import "../../../styles/style.css";
import { useLocation } from "react-router";
import { developerCertificationTabContext, developerCertificationCurrentTabContext } from "../context/developer_certification_context";

const DeveloperCertificationTab = () => {
  const { tabs } = useContext(developerCertificationTabContext);
  const location = useLocation();
  const { currentTab, setTab, setTabByValue } = useContext(developerCertificationCurrentTabContext);

  useEffect(() => {
    if (location.state && location.state.tabValue !== undefined) {
      setTabByValue(location.state.tabValue);
    }
  }, []);

  return (
    <div className="sm:block pb-4">
      {tabs.length > 1 && (
        <nav className="flex space-x-4" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              onClick={() => setTab(tab)}
              className={`button-tab-base ${tab.name === currentTab.name ? "active" : "inactive"}`}
              aria-current={tab.name === currentTab.name ? "page" : undefined}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      )}
    </div>
  );
};

export default DeveloperCertificationTab;
